class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger == 'infinite') {
      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.add('loading');
    this.classList.add('disabled');

    const sections = InfiniteScroll.getSections();
    sections.forEach(() => {
      const url = this.dataset.url;
      InfiniteScroll.renderSectionFromFetch(url);
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static renderSectionFromFetch(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        InfiniteScroll.renderPagination(html);
        InfiniteScroll.renderProductGridContainer(html);
      })
      .catch((e) => {
        console.error(e);
      })
     .finally(() => {
        const quick_buttons = document.querySelectorAll(".custom_quick_add_btn");
        const quick_close_buttons = document.querySelectorAll(".quick_add__close-button");
        const quick_select = document.querySelectorAll(".custom_add_select");

        for (let i = 0; i < quick_buttons.length; i++) {
          const newButton = quick_buttons[i].cloneNode(true);
          quick_buttons[i].parentNode.replaceChild(newButton, quick_buttons[i]);
          newButton.addEventListener('click', function() {
            console.log("clicked");
            const nextElement = this.nextElementSibling;
            toggle_quick_view(newButton, nextElement);
          });
        }

        for (let i = 0; i < quick_close_buttons.length; i++) {
          const newCloseButton = quick_close_buttons[i].cloneNode(true);
          quick_close_buttons[i].parentNode.replaceChild(newCloseButton, quick_close_buttons[i]);
          newCloseButton.addEventListener('click', function() {
            const container = this.closest('.custom_quick_add_container');
            const quickButton = container.parentElement.querySelector('.custom_quick_add_btn');
            var dataId = newCloseButton.getAttribute('data-id');
            var elementToShowId = dataId;
            var elementToShow = document.getElementById(elementToShowId);
            container.style.display = "none";
            quickButton.style.display = "block";
            elementToShow.style.display = "block";
          });
        }

        for (let i = 0; i < quick_select.length; i++) {
          const newSelect = quick_select[i].cloneNode(true);
          quick_select[i].parentNode.replaceChild(newSelect, quick_select[i]);
          newSelect.addEventListener('change', function() {
            var dataSelectId = newSelect.getAttribute('data-price-element');
            var elementToUpdate = dataSelectId;
            var elementToUpdatePrice = document.getElementById(elementToUpdate);
            var priceValue = this.querySelector(':checked').getAttribute('data-price');
            elementToUpdatePrice.innerHTML = priceValue;
          });
        }

        function toggle_quick_view(clicked_element, element) {
          var dataId = clicked_element.getAttribute('data-id');
          var elementToHideId = dataId;
          var elementToHide = document.getElementById(elementToHideId);
          if (element.style.display === "block") {
            element.style.display = "none";
            clicked_element.style.display = "block";
            elementToHide.style.display = "block";
          } else {
            element.style.display = "block";
            clicked_element.style.display = "none";
            elementToHide.style.display = "none";
          }
        }
      });
  }

  static renderPagination(html) {
    const container = document.getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    const pagination = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    if (pagination) {
      container.innerHTML = pagination.innerHTML;
    }
    else {
      container.remove();
    }
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('product-grid');
    const products = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
    container.insertAdjacentHTML('beforeend', products.innerHTML);
  }
}
customElements.define('infinite-scroll', InfiniteScroll);
